import { doRequestPost } from '../../../api';
import { promiseCatch } from '../../../utils/promise';
import { doToast } from '../../../utils';
import { setJwt, setSession, sessionClear, setStartLoading, setPageData } from './sessionSlice';
import { setSessionCustomer } from '../session-customer';

export const getSession = () => {
  return async (dispatch) => {
    dispatch(setStartLoading());

    try {
      const userSession = await doRequestPost({
        url: '/auth/session',
      })
      
      const getDataPage = await doRequestPost({
        url: '/event/ecommerce/get/public',
        data: {
          p_search: '',
          p_id_type_event: null,
        }
      })

      if (getDataPage.response === 'success') {
        dispatch(setPageData({
          events: getDataPage.data,
          banners: getDataPage.data,
          categories: getDataPage.data,
        }));
      }

      if (userSession.response === 'success') {
        dispatch(setJwt({
          jwt: userSession.data.jwt
        }));
        dispatch(setSession({
          full_name: userSession.data.full_name,
          photo_user: userSession.data.photo_user,
          main_profile: userSession.data.main_profile,
          notifications: userSession.data.notifications,
          permissions: userSession.data.permissions,
          username: userSession.data.username,
          super_admin_user: userSession.data.super_admin_user,
          key_customer: userSession.data.key_customer,
          type: userSession.data.type,
        }));

        if (userSession.data.type === 'customer') {
          localStorage.setItem('session-customer-storage', userSession.data.key_customer);
          dispatch(setSessionCustomer({
            id_customers_reservation_event_zone: userSession.data.key_customer
          }));
        }
      } else {
        dispatch(sessionClear());
      }
    } catch (error) {
      dispatch(sessionClear());
    }
  }
}

export const doLogin = ({
  toast,
  data
}) => {
  const { p_password, p_username, p_old_key_customer, always } = data
  return async (dispatch) => {
    try {
      const usersLogin = await doRequestPost({
        url: '/auth/login',
        data: {
          p_password,
          p_username,
          p_old_key_customer
        }
      })
      if (usersLogin.response === 'success') {
        const { jwt } = usersLogin.data
        dispatch(setJwt({ jwt }))
        await dispatch(getSession())
      } else {
        doToast({
          ...usersLogin,
          toast
        })
        always()
      }
    } catch (error) {
      promiseCatch({
        toast
      })
      always()
    }
  }
}